import { addPermissionsToRoute } from '@/myq-core/';

const routes = {
  name: 'Digital',
  icon: 'mdi-laptop',
  path: '/reports/mcd/digital/',
  children: [
    {
      path: '/reports/mcd/digital/dashboard',
      name: 'Digital At A Glance',
      meta: { id: 'reports-digitalAtAGlance' },
      component: () => import('./dashboard/DigitalDashboard.vue'),
      ...addPermissionsToRoute(['mobileAppSummary']),
      tags: ['Mobile Order/Pay', 'Digital Dashboard'],
    },
    {
      path: '/reports/mcd/digital/mobileApp',
      name: 'Digital App',
      meta: { id: 'reports-digitalApp' },
      component: () => import('./DigitalApp.vue'),
      ...addPermissionsToRoute(['mobileAppSummary']),
      tags: ['Loyalty'],
    },
    {
      path: '/reports/mcd/digital/digitalUsage',
      name: 'Digital Usage',
      meta: { id: 'reports-digitalUsage' },
      component: () => import('./DigitalUsage.vue'),
      ...addPermissionsToRoute(['mobileAppSummary']),
    },
    {
      path: '/reports/mcd/digital/digitalDelivery',
      name: 'GMA Delivery',
      meta: { id: 'reports-gmaDelivery' },
      component: () => import('./GMA/GMAWrapper.vue'),
      ...addPermissionsToRoute(['gmaDelivery']),
    },
    {
      path: '/reports/mcd/digital/nationalEmployeeDiscount',
      name: 'National Employee Discount (NED)',
      meta: { id: 'reports-nationalEmployeeDiscount' },
      component: () => import('./NED/NEDWrapper.vue'),
      ...addPermissionsToRoute(['nationalEmployeeDiscount']),
    },
    {
      path: '/reports/mcd/digital/mobileProfitAndLossDetail',
      name: 'Mobile P&L Detail',
      meta: { id: 'reports-mobileProfitAndLossDetail' },
      component: () => import('./mobilePNL.vue'),
      ...addPermissionsToRoute(['mobileProfitAndLossDetail']),
    },
    {
      path: '/reports/mcd/digital/mobileOffersList',
      name: 'Mobile Offer List',
      meta: { id: 'reports-mobileOfferList' },
      component: () => import('./mobileOfferList.vue'),
      ...addPermissionsToRoute(['mobileOfferList']),
    },
  ],
};

export default routes;
